import { useFeature } from '@mafc/appshell';
import { GROWTHBOOK_FLAGS } from 'pages/NewCart/constants/growthbook.constants';

const useCartRevampEnabled = () => {
  return useFeature(GROWTHBOOK_FLAGS.CART_REVAMP_ENABLED).on;
};

export default useCartRevampEnabled;
